<template>
  <admin-table
    ref="table"
    :api-builder="apiBuilder"
    :columns="columns"
    :row-actions="rowActions"
    :bulk-actions="[]"
    :search-fields="null"
    :on-delete-item="onDeleteItem"
  >
    <template v-slot:direction="{ item }">
      {{ $t(`general.${item.direction}`) }}
    </template>

    <template v-slot:is_main="{ item }">
      <i :class="{ 'text-success icon-checkmark': item.is_main }"></i>
    </template>
  </admin-table>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'

export default {
  components: {
    AdminTable,
  },

  props: {
    apiBuilder: {
      type: Function,
      required: true,
    },
  },

  computed: {
    columns() {
      return [
        {
          key: 'company.name',
          label: this.$t('companies.name'),
        },
        {
          key: 'direction',
          label: this.$t('general.direction'),
        },
        {
          key: 'is_main',
          label: this.$t('general.main'),
        },
      ]
    },
  },

  methods: {
    rowActions(item) {
      let actions = ['delete']

      if (!item.is_main) {
        actions.unshift({
          label: this.$t('general.main'),
          handler: () => {
            this.makeMain(item)
          },
        })
      }

      return actions
    },
    editing(item) {
      this.$emit('edit', item)
    },
    refresh() {
      this.$refs.table.refresh()
    },
    makeMain(item) {
      const promise = this.apiBuilder()
        .makeMain(item.company.id)
        .then(() => {
          this.refresh()
        })
      this.$uiBlocker(promise, this.$refs.table.$el)
    },
    onDeleteItem(item) {
      const promise = this.apiBuilder()
        .destroy(item.company.id)
        .then(() => {
          this.refresh()
        })

      this.$uiBlocker(promise, this.$refs.table.$el)
    },
  },
}
</script>
